import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import * as moment from 'moment';
import { TimeParseDirective } from './../../directives/time-parse.directive';

@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimePickerComponent implements OnChanges {

  @Input()
  value: string;

  @Input()
  editMode: boolean;

  @Input()
  defaultValue = '00:00';

  @Output()
  valueChange$ = new EventEmitter();

  @ViewChild(TimeParseDirective) input: TimeParseDirective;

  emptyValue = '00:00';
  timeFormatWithSeconds = 'HH:mm:ss';
  timeFormat = 'HH:mm';
  arrowChangeValue = 60;

  constructor() { }

  ngOnChanges(): void {
    this.parseInput();
  }

  parseInput() {
    this.value = this.parseValue();

    if (this.value && this.input && !this.input.regexPatterns.hoursAndMinutesCompleted.pattern.test(this.value)) {
      this.value = '';
      this.input.syncValue('');
    }
  }

  parseValue(): string {
    let result = moment(this.value, this.timeFormat, true).format(this.timeFormat);

    if (result === 'Invalid date') {
      result = moment(this.value, this.timeFormatWithSeconds, true).format(this.timeFormat);
    }

    return result;
  }

  valueIsValid(): boolean {
    return !this.input || this.input.valueIsValid();
  }

  add() {
    this.changeValue(this.arrowChangeValue);
  }

  reduce() {
    this.changeValue(-1 * this.arrowChangeValue);
  }

  changeValue(addMinutes: number) {
    const parsedValue = moment(this.value, this.timeFormat, true).add(addMinutes, 'minutes').format(this.timeFormat);

    this.value = this.isValid(parsedValue) ? parsedValue : '00:00';
    this.propagateValue(this.value);
  }

  propagateValue(value: string, initialValue: boolean = false) {
    if (initialValue || this.input.regexPatterns.hoursAndMinutesCompleted.pattern.test(value)) {
      this.input.syncValue(value);
      this.valueChange$.emit({ value });
    }
  }

  private isValid(value: string) {
    return moment(value, this.timeFormat, true).isValid();
  }
}
